
export const convertRoutesToUseIdParams = (routes: Record<string, string>): Record<string, string> => {
  const updatedRoutes: Record<string, string> = { ...routes };
  
  // Identify patterns for view/edit/detail routes
  Object.keys(updatedRoutes).forEach(key => {
    // Common patterns for detail views
    if (
      key.startsWith('VIEW_') || 
      key.startsWith('EDIT_') || 
      key.startsWith('DETAIL_') ||
      key.includes('_VIEW_') || 
      key.includes('_EDIT_') || 
      key.includes('_DETAIL_')
    ) {
      if (!updatedRoutes[key].includes(':')) {
        updatedRoutes[key] = `${updatedRoutes[key]}/:id`;
      }
    }
  });
  
  return updatedRoutes;
};


export const generateRouteWithId = (basePath: string, id: string | number | Record<string, any>): string => {
  if(id && typeof id === 'object') {
    Object.entries(id).map(([key, value]) => {
      basePath = basePath.replace(`:${key}`, value?.toString());
    })
  } else if (basePath.includes(':id')) {
    return basePath.replace(':id', id?.toString());
  }
  
  // If the path doesn't have an :id parameter, append it
  return `${basePath}`;
};


export const updatePathnameWithIdParams = <T extends Record<string, string>>(pathnameObject: T): T => {
  return convertRoutesToUseIdParams(pathnameObject) as T;
}; 

// Added utility for navigating to views with id parameter
export const navigateToRouteWithId = (
  navigate: any,
  route: string, 
  id: string | number,
  state?: any
) => {
  const path = generateRouteWithId(route, id);
  navigate(path, { state });
}; 